<template>
  <div class="row">
    <div class="col-md-12">
      <fieldset :disabled="pageType === 'view'">
        <div class="widget fluid">
          <div class="whead">
            <h6>Basic Info</h6>
          </div>
          <div class="card-body card-block">
            <form
              action
              method="post"
              enctype="multipart/form-data"
              class="form-horizontal"
              v-on:submit.prevent="save()"
            >
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="name" class="form-control-label" v-required>Name</label>
                </div>
                <div class="col-12 col-md-9">
                  <input
                    type="text"
                    id="name"
                    name="name"
                    placeholder
                    class="form-control"
                    v-model="input.name"
                    ref="name"
                  >
                </div>
              </div>
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="short_name" class="form-control-label" v-required>Short Name</label>
                </div>
                <div class="col-12 col-md-9">
                  <input
                    type="text"
                    id="short_name"
                    name="short_name"
                    placeholder
                    class="form-control"
                    v-model="input.short_name"
                    ref="short_name"
                  >
                </div>
              </div>
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="structure" class="form-control-label" v-required>Product Structure</label>
                </div>
                <div class="col-12 col-md-9">
                  <div>
                    <div v-if="!modelID">
                      <button
                        type="button"
                        class="btn btn-primary"
                        @click="addField()"
                      >Add New Field</button>
                    </div>
                    <div class="list-group-item d-flex bg-light">
                      <div class="col col-5">Name (CN)</div>
                      <div class="col col-5">Name (EN)</div>
                      <div class="col col-2" v-if="!modelID">Action</div>
                    </div>
                  </div>
                  <ul class="list-group">
                    <draggable v-model="input.structure">
                      <li
                        class="list-group-item d-flex"
                        v-for="(element,i) in input.structure"
                        :key="i"
                      >
                        <div class="col col-5">
                          <input class="form-control" v-model="input.structure[i].field_name.tc">
                        </div>
                        <div class="col col-5">
                          <input class="form-control" v-model="input.structure[i].field_name.en">
                        </div>
                        <div class="col col-2" v-if="!modelID">
                          <button
                            type="button"
                            class="item"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Delete"
                            @click="removeStructureItem(element)"
                          >
                            <i class="zmdi zmdi-delete"></i>
                          </button>
                        </div>
                      </li>
                    </draggable>
                  </ul>
                </div>
              </div>
            </form>
          </div>
        </div>
      </fieldset>
    </div>
  </div>
</template>
<script>

import save from 'src/global/save.js'
import back from 'src/global/back.js'
import getData from 'src/global/getData.js'
import createItem from 'src/global/createItem.js'
import updateItem from 'src/global/updateItem.js'
import validation from 'src/global/validation.js'

import draggable from 'vuedraggable'

import ProductCategoryModel from './model/ProductCategory'

export default {
  components: {
    draggable
  },
  data() {
    return {
      pageSettings: {
        pageTitle: 'Product Category',
        sectionName: 'product.category',
        sectionIcon: 'fas fa-glass',
        type: this.pageType,
        useDefault: true,
        webService: this.$root.WebService.productCategory,
        modelID: this.$route.params.id ? this.$route.params.id : null,
        navigation: [
          { name: 'Product', route: 'product.index' },
          { name: 'Product Category', route: 'product.category.index' },
          { name: this.$route.params.id ? 'Edit' : 'Create' },
        ],
        buttons: [
          (this.pageType !== 'view' ? { name: 'Save', icon: 'fas fa-save', action: this.save } : null),
          { name: 'Back', icon: 'fas fa-arrow-left', action: this.back },
        ],
        subSidebar: {
          buttons: [
            { name: 'Product List', icon: 'fas fa-file-download', action: () => { this.$router.push({ name: 'product.index' }) } },
            { name: 'Product Categories', icon: 'fas fa-file-download', action: () => { this.$router.push({ name: 'product.category.index' }) } },
          ]
        }
      },
      input: ProductCategoryModel(),
      requiredInput: [
        {key: 'name', title: 'Name'},
        {key: 'short_name', title: 'Short Name'},
      ],

      userPermissions: [],
      modelID: this.$route.params.id ? this.$route.params.id : null,
      processing: false,
    }
  },
  props: {
    pageType: String
  },
  created() {
    this.getData()
  },
  mounted() {
    this.$emit('setPageHeader', this.pageSettings)
  },
  methods: {
    addField() {
      this.input.structure.push({
        field_name: {
          tc: null,
          en: null
        }
      })
    },
    removeStructureItem(item) {
      let index = this.input.structure.indexOf(item)
      this.input.structure.splice(index, 1)
    },
    back,
    save,
    getData,
    createItem,
    updateItem,
    validation
  }
}
</script>